<template>
  <div class="space-y-4">
    <!-- Top row -->
    <div class="flex gap-4 h-[33vh]">
      <!-- Left panel (2/3) -->
      <div class="w-2/3 bg-white border border-gray-200 rounded-lg flex flex-col">
        <div class="px-4 py-3 border-b border-gray-200 shrink-0">
          <h3 class="text-sm font-semibold text-gray-900">Progress to Goal</h3>
        </div>
        <div class="flex-1 flex">
          <div class="w-1/2 border-r border-gray-200 p-4">
            <h4 class="text-xs font-medium text-gray-500 mb-2">Lives Current and Projected</h4>
          </div>
          <div class="w-1/2 p-4">
            <h4 class="text-xs font-medium text-gray-500 mb-2">Projected Avg. Benchmark Costs</h4>
          </div>
        </div>
      </div>
      <!-- Right panel (1/3) -->
      <div class="w-1/3 bg-white border border-gray-200 rounded-lg flex flex-col">
        <div class="px-4 py-3 border-b border-gray-200 shrink-0">
          <h3 class="text-sm font-semibold text-gray-900">Funnel</h3>
        </div>
        <div class="flex-1 overflow-y-auto"></div>
      </div>
    </div>

    <!-- Bottom row -->
    <div class="flex gap-4 h-[33vh]">
      <!-- Upcoming To-Dos -->
      <div class="w-1/2 bg-white border border-gray-200 rounded-lg flex flex-col">
        <div class="px-4 py-3 border-b border-gray-200 shrink-0">
          <h3 class="text-sm font-semibold text-gray-900">Upcoming To-Dos</h3>
        </div>
        <div class="flex-1 overflow-y-auto"></div>
      </div>
      <!-- Upcoming Calls -->
      <div class="w-1/2 bg-white border border-gray-200 rounded-lg flex flex-col">
        <div class="px-4 py-3 border-b border-gray-200 shrink-0">
          <h3 class="text-sm font-semibold text-gray-900">Suggested Prospects</h3>
        </div>
        <div class="flex-1 overflow-y-auto"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProspectsV2Tab',
}
</script>
